<template>
    <form
        @submit.prevent="handleSubmit"
        class="form-container basic-search-form claimsvault"
        data-cy="basic-search-container"
    >
        <div class="flex w-full">
            <div class="flex flex-col w-3/4 md:w-4/5 pr-2" data-cy="field-basic-search">
                <ui-input
                    v-model="search_form.basic_search"
                    class="py-4 px-6 border-default-purple"
                    :placeholder="$t('claims.search_form.placeholders.basic_search')"
                />
            </div>
            <div class="flex flex-col w-1/4 md:w-1/5 pl-2">
                <ui-submit-button class="2xl:w-2/3 text-xl h-full" data-cy="button-find" :disabled="processing">
                    <span v-if="!processing">{{ $t('claims.search_form.buttons.find') }}</span>
                    <span v-else>{{ $t('claims.search_form.buttons.finding') }}</span>
                </ui-submit-button>
            </div>
        </div>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';

export default {
    components: {
        UiInput,
        UiSubmitButton,
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
        search_form: {
            type: Object,
            default: {},
        },
    },
    methods: {
        handleSubmit() {
            this.$emit('formSubmit');
        },
    },
};
</script>
